import React from 'react';

export const MessageSquare = ({ className = 'w-6 h-6', ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3 1.5-4.5A4 4 0 0 1 3 15V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" />
    <path d="M7.5 8.5h9" opacity="0.6" />
    <path d="M7.5 12h6" opacity="0.6" />
  </svg>
);
